export default {
  filters: {
    managers: {
      placeholder: 'Responsabili vendite',
    },
  },
  metrics: {
    collected_commission: 'Commissione totale',
  },
  fields: {
    manager: 'Manager',
    area: 'Sede',
    total_amount: 'Guadagni',
    companies_live: 'Live',
    restaurant: 'Ristorante',
    live_from: 'Attivo dal',
    plan_amount: 'Importo piano',
    prepayment_bonus_amount: 'Bonus pagamento anticipato',
    lead_source_bonus_amount: 'Bonus fonte lead',
    google_business_bonus_amount: 'Bonus connessione Google Business',
    promo_code_bonus_amount: 'Bonus codice promo master',
    smart_pricing_bonus_amount: 'Bonus prezzi intelligenti',
    mobile_app_bonus_amount: 'Bonus app mobile',
    sales_goal_bonus_amount: 'Bonus obiettivo vendite',
  },
  buttons: {
    export: 'Esporta',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
